<template>
  <vs-wrapper space="small">
    <vs-alert type="warn">
      Deleting or renaming an option that has dependencies will result in their deletion
    </vs-alert>
    <vs-text-input
      v-model="bulkEditText"
      label="Add options; each option must be on a separate line"
      multiline
      @input="updateText"
    />
    <div class="buttons-container">
      <vs-button class="pa-3 mr-9 button-half-width" label="Apply" type="primary" @click="apply" />
      <vs-button
        class="pa-3 mr-9 button-half-width"
        label="Cancel"
        type="secondary"
        @click="$emit('cancel')"
      />
    </div>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsAlert from '@/components/vision/VsAlert.vue'

interface Props {
  initialText: string
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'apply', bulkOptions: string[]): void
  (e: 'cancel'): void
}>()

const bulkEditText = ref(props.initialText)

watch(
  () => props.initialText,
  (newText) => {
    bulkEditText.value = newText
  },
)

function updateText(options: string) {
  bulkEditText.value = options
    .split(/\n+/)
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .join('\n')
}

function apply() {
  const bulkOptions = bulkEditText.value
    .split(/\n+/)
    .map((option) => option.trim())
    .filter((option) => option !== '')
  emit('apply', bulkOptions)
}
</script>

<style scoped>
.buttons-container {
  display: flex;
}
.button-half-width {
  flex: 1;
}
</style>
